import type { DashboardObservationCounts } from '../types';

export const EMPTY_OBSERVATION_COUNTS: DashboardObservationCounts = {
  dueWithinWeek: 0,
  dueWithinMonth: 0,
  deadlineBeyond: 0,
  upcoming: 0,
  completed: 0,
  expired: 0,
};
